module.exports = __webpack_public_path__ + "Times_Education_Excellence_2023-8eaeed8f.webp";